import React, { useEffect, useState, FC } from "react";
import { Button, Form, message, Modal, Tag, Tooltip, Upload } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { usePurchaseOfferDetailsModel } from "./purchaseOfferDetailsModel";
import { globalPrompt } from "@/components/message";
import { ITopType } from "@/types/ScmTypes";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { DetailType } from "@/types/ScmEnums";
import { usePurchaseOfferModel } from "../../purchaseOfferModel";
import { debounce } from "lodash";
import FontIcon from "@/components/YhIcon";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { BankOutlined, UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { fileDownload } from "@/utils/exportFile";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";
import moment, { Moment } from "moment"
import { YhBox } from "@/components/YhBox";
import { momentFormat } from "@/utils/utils";

export const FormBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        detailEditForm,
        detailAddForm,
        detailLookForm,
        detailAddList,
        detailDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setTopButsControl,
        setSupplierHistoryModel,
        setSupplierHistoryVisible,
        saveLoading, setSaveLoading,
        Submit, formComputeRule,
        Transfer, topButsControl,
        supplierList, setSupplierList, toReport,
        addSupplierVisible, setAddSupplierVisible,
        secSaveLoading, setSecSaveLoading,
        more, setMore
    } = usePurchaseOfferDetailsModel();
    const {
        setSelectedRowKeys,
        setSelectedRow,
        setDescRows,
    } = usePurchaseOfferModel()
    const { getTreeNodeName } = useDictModel();

    const { beShopDs, supplieAllList, shopAndOrg: { shopId, shopCode, shopName } } = useGlobalModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { getSelectedDictOne } = useDictModel();
    const typeForm: any = {
        add: { ...detailAddForm, shopId, shopCode, shopName },
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        if (mode === DetailType.add) {
            setSupplierList(supplieAllList.map((item: any) => { return { code: item.code, name: item.name } }))
        }
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("11-7-1") && resetAddCatch(mode);
            !findNav("11-7-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])


    const save = () => {
        let goods = mode === "add" ? detailAddList : detailDataSource
        IFormRef.current?.validateFields().then(async res => {
            const { fileList = [], fileList2 = [], ...val } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    console.log(file)
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.md5 = file?.uid
                val.fileName = file?.name
            }
            else {
                val.md5 = ''
                val.fileName = ''
            }
            if (fileList2.length > 0) {
                const file = fileList2[0]
                if (!file?.uid) {
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.supplierMd5 = file?.uid
                val.supplierFileName = file?.name
            } else {
                val.supplierMd5 = ''
                val.supplierFileName = ''
            }
            val.endTime = val.endTime ? moment(val.endTime).format("YYYY-MM-DD 23:59:59") : null
            if (mode === "add") {
                const resData = await insertDetail(val)
                if (resData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    resetAddCatch(mode);
                    goBack();
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
            } else if (mode === "edit") {
                let { id, offerCode } = detailEditForm
                const resData = await editDetail({ ...detailEditForm, ...val, id, offerCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(id as string, mode)
                }
            }
        })
    }
    const submitReport = async () => {
        if (!formComputeRule(mode)) return;
        globalPrompt("modal", {
            title: "报价提报",
            type: "warning",
            text: `您正提报此条单据，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                setSecSaveLoading(true)
                const resData = await toReport(id)
                setSecSaveLoading(false)
                if (resData) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "报价单提报成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "报价单提报失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "11-7")
    }
    const onSubmit = async () => {
        globalPrompt("modal", {
            title: "发布询价",
            type: "warning",
            text: `您正发布此条单据，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await Submit()
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "询价单发布成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "询价单发布失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )

    }
    const onTrunPo = async (value: any, message: any) => {
        globalPrompt("modal", {
            title: "询价审核",
            type: "warning",
            text: `您正在询价此条单据'${message}'，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await Transfer(value)
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "审核成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "审核失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )
    }
    const rightChildren = <>
        {mode !== "look" && typeForm[mode]?.status === "purchase_enquiry.underway" && <>
            <YhAuth resCode={ResourceAuthEnum.P_OFFER_SUBMITREPORT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={secSaveLoading}
                    disabled={topButsControl}
                    onClick={debounce(() => { submitReport() }, 900)}
                >{secSaveLoading ? '提报中' : '提报'}</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_OFFER_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        </>
        }
        <YhAuth resCode={ResourceAuthEnum.P_OFFER_GOBACK}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={goBack}
            >返回</Button>
        </YhAuth>
    </>;

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const disabledDate = (current: Moment) => {
        return current && current < moment(typeForm[mode].endTime)
    }
    const typeChange = (value: string, option: ISelectOption) => {
        option && onChange({ typeName: option.label, type: option.value });
        if (value == 'Inquiry-type.002') {
            setSupplierList([])
        } else {
            setSupplierList(supplieAllList.map((item: any) => { return { code: item.code, name: item.name } }))
        }
    }
    const title = <>
        <span>基础信息</span>

        {<a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>}
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "询价标题",
                fieldName: "title",
                disable: true,
                hidden: more,
                rules: [{ required: true, message: "请输入询价标题" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "报价截止时间",
                format: "YYYY-MM-DD HH:mm:ss",
                showTime: { defaultValue: moment("00:00:00", "HH:mm:ss") },
                fieldName: "endTime",
                disable: true,
                hidden: more,
                rules: [{ required: true, message: "请选择截止时间" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                disable: true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属站点",
                fieldName: "shopName",
                disable: true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "报价人",
                fieldName: "createUser",
                disable: true,
                placeholder: "自动生成",
                hidden: more,
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "报价时间",
                fieldName: "createTimes",
                disable: true,
                placeholder: "自动生成",
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编辑人",
                fieldName: "updateUser",
                disable: true,
                placeholder: "自动生成",
                hidden: more,
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编辑时间",
                fieldName: "updateTimes",
                disable: true,
                placeholder: "自动生成",
                hidden: more,
                // colClassName:"iscm-ant-col-5"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商备注",
                fieldName: "supplierNote",
                hidden: more,
            }, {
                type: FormItemTypeEnum.Other,
                fieldLabel: "",
                fieldName: "",
                span: 12,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                hidden: more,
                span: 12,
                // hidden: mode == 'look' && !detailLookForm.md5 ? true : false,
                formItem: (
                    <Form.Item name="fileList" label="询价附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            disabled={true}
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )

                            }}
                        >
                            {/* {mode !== 'look' &&
                                <>
                                    <Button icon={<UploadOutlined />} >选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>} */}
                        </Upload>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                hidden: more,
                span: 12,
                // hidden: mode == 'look' && !detailLookForm.supplierMd5 ? true : false,
                formItem: (
                    <Form.Item name="fileList2" label="报价附件" valuePropName="fileList2" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            fileList={typeForm[mode]?.fileList2}
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            disabled={mode == 'look'}
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )

                            }}
                        >
                            {mode !== 'look' &&
                                <>
                                    <Button icon={<UploadOutlined />} >选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>}
                        </Upload>
                    </Form.Item>
                ),
            },
        ]
    };


    const onChange = (changedValues: { [key: string]: any }) => {
        let newChangedValues = changedValues;
        mode === "add" ? updateAddFormVal(newChangedValues) : updatEditFormVal(newChangedValues);
        setTopButsControl(true)
    }


    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode === DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    const action = <>
        {mode !== "look" &&
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                disabled={!(mode == "add" || (mode == "edit" && detailEditForm.status == "purchase_enquiry.underway"))}
                onClick={() => setAddSupplierVisible(true)}
            >追加供应商</Button>
        }
    </>;
    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        询价单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode]?.code ?? "暂无"}</span>
                        单据状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: 'red' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}